import React, { useRef } from "react";
import { ArrowRight, CalendarDays } from "lucide-react";
import { Button } from "./ui/button";
import { useInView } from "../hooks/useInView";
import { ctaContent, images } from "../data/mock";

export const CTASection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.2 });

  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={sectionRef} className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={images.cta}
          alt="DJ Equipment"
          className="w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{ backgroundColor: "rgba(15,15,15,0.87)" }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className={isInView ? "animate-fade-in-up" : "opacity-0"}>
          <CalendarDays className="h-12 w-12 text-gold mx-auto mb-6" />

          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {ctaContent.headline}
          </h2>

          <p className="text-white/60 text-lg leading-relaxed max-w-2xl mx-auto mb-4">
            {ctaContent.subheadline}
          </p>

          <p className="text-gold text-sm font-medium mb-10">
            {ctaContent.urgency}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={scrollToContact}
              className="bg-gold hover:bg-gold-dark text-white font-semibold px-10 h-14 text-base rounded-full shadow-lg shadow-gold/20"
            >
              {ctaContent.primaryCTA}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              onClick={scrollToContact}
              variant="outline"
              className="border-white/30 text-white hover:bg-white/10 hover:text-white font-semibold px-10 h-14 text-base rounded-full"
            >
              {ctaContent.secondaryCTA}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
